<div class="report-create-report">
  <app-loader *ngIf="isLoading"></app-loader>

  <div class="create-report-type">
    <h2 class="title">{{ labels.GENERATE_REPORT.TITLE }}</h2>
    <div class="custom-stepper">
      <div class="step" [class.active]="step() === 1" [class.done]="step() !== 1">
         <div class="circle">
          <div class="initial-center">1</div>
         </div>
        <div class="label">{{ labels.COMMON.STEPS.INITIATE }}</div>
      </div>
      <div class="line"></div>
      <div class="step" [class.active]="step() === 2">
        <div class="circle">
          <div class="initial-center">2</div>
        </div>
        <div class="label">{{ labels.COMMON.STEPS.ANALYZED }}</div>
      </div>
      <div class="line"></div>
      <div class="step" [class.active]="step() === 3">
        <div class="circle">
          <div class="initial-center">3</div>
        </div>
        <div class="label">{{ labels.COMMON.STEPS.REVIEW }}</div>
      </div>
      <div class="line"></div>
      <div class="step" [class.active]="step() === 4">
        <div class="circle">
          <div class="initial-center">4</div>
        </div>
        <div class="label">{{ labels.COMMON.STEPS.APPROVED }}</div>
      </div>
    </div>
  </div>

  @if (recipeDefinition()) {
  <div class="recipe-info">
    <h3>{{ recipeDefinition()!.recipeName }}</h3>
    <p class="recipe-description">{{ recipeDefinition()!.description }}</p>
  </div>

  <div class="report-form">
    <p class="help-text">{{ labels.GENERATE_REPORT.HELP_TEXT }}</p>
    <form [formGroup]="fixedForm">
      <div class="form-container">
        <div class="form-field">
          <label for="reportName">
            {{ labels.GENERATE_REPORT.REPORT_NAME }}
            <span class="required">*</span>
          </label>
          <input
            type="text"
            id="reportName"
            formControlName="reportName"
            [placeholder]="labels.GENERATE_REPORT.REPORT_NAME_PLACEHOLDER"
            maxlength="100"
          />
          <div class="error-message"
            *ngIf="fixedForm.get('reportName')?.touched && fixedForm.get('reportName')?.invalid">
            <span *ngIf="fixedForm.get('reportName')?.errors?.['required']">{{ labels.GENERATE_REPORT.REPORT_NAME_REQUIRED }}</span>
            <span *ngIf="fixedForm.get('reportName')?.errors?.['maxlength']">{{ labels.GENERATE_REPORT.REPORT_NAME_MAX_LENGTH }}</span>
          </div>
        </div>
        <div class="form-field">
          <label for="projectId">
            {{ labels.GENERATE_REPORT.PROJECT_ID }}
            <span class="required">*</span>
          </label>
          <input
            type="text"
            id="projectId"
            formControlName="projectId"
            [placeholder]="labels.GENERATE_REPORT.PROJECT_ID_PLACEHOLDER"
            maxlength="8"
          />
          <div class="error-message"
            *ngIf="fixedForm.get('projectId')?.touched && fixedForm.get('projectId')?.invalid">
            <span *ngIf="fixedForm.get('projectId')?.errors?.['required']">{{ labels.GENERATE_REPORT.PROJECT_ID_REQUIRED }}</span>
            <span *ngIf="fixedForm.get('projectId')?.errors?.['pattern']">{{ labels.GENERATE_REPORT.PROJECT_ID_PATTERN }}</span>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="report-form">
    <p class="help-text">{{ labels.GENERATE_REPORT.TEMPLATE_VARIABLES }}</p>
    <form [formGroup]="dynamicForm" (ngSubmit)="onSubmit()">
      <div class="form-container">
        @for (variable of variables(); track variable.variableId) {

        <!-- FreeText -->
        @if (variable.type === 'FreeText') {
        <div class="form-field">
          <label [for]="variable.name">
            {{ variable.label }}
            <span class="required" *ngIf="variable.isRequired">*</span>
          </label>
          <input
            type="text"
            [id]="variable.name"
            [formControlName]="variable.name"
            [placeholder]="'Enter ' + variable.label"
            [attr.maxlength]="variable.validation?.maxLength"
          />
          <div class="error-message"
            *ngIf="getControl(variable.name).touched && getControl(variable.name).invalid">
            {{ variable.validation?.errorMessage || variable.label + ' is required.' }}
          </div>
        </div>
        }

        <!-- Number -->
        @if (variable.type === 'Number') {
        <div class="form-field">
          <label [for]="variable.name">
            {{ variable.label }}
            <span class="required" *ngIf="variable.isRequired">*</span>
          </label>
          <input
            type="number"
            [id]="variable.name"
            [formControlName]="variable.name"
            [placeholder]="'Enter ' + variable.label"
            [attr.min]="variable.numberConfig?.minValue"
            [attr.max]="variable.numberConfig?.maxValue"
            [attr.step]="variable.numberConfig?.precision === 0 ? 1 : 'any'"
          />
          <div class="error-message"
            *ngIf="getControl(variable.name).touched && getControl(variable.name).invalid">
            {{ variable.validation?.errorMessage || variable.label + ' is required.' }}
          </div>
        </div>
        }

        <!-- Selection (single) -->
        @if (variable.type === 'Selection') {
        <div class="form-field">
          <label [for]="variable.name">
            {{ variable.label }}
            <span class="required" *ngIf="variable.isRequired">*</span>
          </label>
          <select [id]="variable.name" [formControlName]="variable.name">
            <option value="" disabled>Select {{ variable.label }}</option>
            @for (option of variable.options; track option) {
            <option [value]="option">{{ option }}</option>
            }
          </select>
          <div class="error-message"
            *ngIf="getControl(variable.name).touched && getControl(variable.name).invalid">
            {{ variable.validation?.errorMessage || variable.label + ' is required.' }}
          </div>
        </div>
        }

        <!-- MultiSelection -->
        @if (variable.type === 'MultiSelection') {
        <div class="form-field form-field--full">
          <label>
            {{ variable.label }}
            <span class="required" *ngIf="variable.isRequired">*</span>
          </label>
          <div class="multi-select-options">
            @for (option of variable.options; track option) {
            <label class="checkbox-label">
              <input
                type="checkbox"
                [checked]="isOptionSelected(variable.name, option)"
                (change)="toggleMultiSelection(variable.name, option)"
              />
              {{ option }}
            </label>
            }
          </div>
          <div class="error-message"
            *ngIf="getControl(variable.name).touched && getControl(variable.name).invalid">
            {{ variable.validation?.errorMessage || labels.GENERATE_REPORT.MULTISELECT_REQUIRED }}
          </div>
        </div>
        }

        <!-- Boolean -->
        @if (variable.type === 'Boolean') {
        <div class="form-field">
          <label class="checkbox-label boolean-field">
            <input
              type="checkbox"
              [formControlName]="variable.name"
            />
            {{ variable.label }}
          </label>
        </div>
        }

        <!-- Date -->
        @if (variable.type === 'Date') {
        <div class="form-field">
          <label [for]="variable.name">
            {{ variable.label }}
            <span class="required" *ngIf="variable.isRequired">*</span>
          </label>
          <app-date-picker
            [id]="variable.name"
            [formControlName]="variable.name"
            [placeholder]="'Select ' + variable.label"
            [minDate]="variable.validation?.minDate ?? null"
            [maxDate]="variable.validation?.maxDate ?? null"
          ></app-date-picker>
          <div class="error-message"
            *ngIf="getControl(variable.name).touched && getControl(variable.name).invalid">
            {{ variable.validation?.errorMessage || variable.label + ' is required.' }}
          </div>
        </div>
        }

        }
      </div>
    </form>
  </div>

  <div class="report-form">
    <app-file-provisioning
      [projectId]="projectIdForFiles"
      [client]="recipeDefinition()?.clientId ?? null"
      [locked]="isLoading"
      (generationAllowedChange)="filesReady.set($event)"
      (uploadIdChange)="onUploadIdChange($event)">
    </app-file-provisioning>
  </div>

  <div class="page-action">
    <button type="button" class="aecom_btn" (click)="onCancel()">{{ labels.COMMON.CANCEL }}</button>
    <button type="button" class="aecom_btn--solid" (click)="onSubmit()"
      [disabled]="generateDisabled">{{ labels.GENERATE_REPORT.GENERATE_BUTTON }}</button>
  </div>
  }
</div>

<app-dialogue-box
  [isDialogOpen]="isDialogOpen"
  [title]="labels.COMMON.SUCCESS"
  [message]="dialogMessage"
  [confirmButtonText]="labels.COMMON.OK"
  [closeButtonText]="labels.COMMON.CLOSE"
  (onClose)="onDialogClose()"
  (onConfirm)="onDialogClose()"
></app-dialogue-box>